import classnames from 'classnames';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import { Translations, convertStringToArrayForOption } from '../../../utils';

import './MultiLineSelect.css';

// Multiline select component
class MultiLineSelect extends Component {

	constructor(props) {
		super(props)

		this.state = {
			listShow: false,
			showEdit: this.props.showEdit || false,
			selectedOptionValue: undefined,
			selectedOption: undefined,
			valueRow1: '',
			valueRow2: '',
			valueRow3: '',
			value: '',
			bold: '',
			normal: '',
			defaultValue: this.props.defaultValue,
			multiAccount: false
		}
	}

	// handle outside click
	handleWindowClick = () => {
		this.setState({
			listShow: false
		});
	}

	// life cycle hook
	componentDidMount() {
		window.addEventListener('click', this.handleWindowClick);
		if (this.props.value !== undefined) {
			const selectedOptionValue = this.props.value;
			let selectedOption;
			this.props.data.forEach(optionData => {
				if (optionData.lid === this.props.value) {
					selectedOption = optionData;

					var row1Val = this.generateText(this.props.requiredFields.row1, optionData, this.props.requiredFieldsPrefixes.row1, this.props.formatters.row1)
					var row2Val = this.generateText(this.props.requiredFields.row2, optionData, this.props.requiredFieldsPrefixes.row2, this.props.formatters.row2)
					var row3Val = this.generateText(this.props.requiredFields.row3, optionData, this.props.requiredFieldsPrefixes.row3, this.props.formatters.row3)

					var bold = row1Val.split(' ').slice(0, 3).join(' ');
					var normal = row1Val.split(' ').slice(3).join(' ');
					this.setState({
						selectedOption,
						selectedOptionValue,
						valueRow1: row1Val,
						valueRow2: row2Val,
						valueRow3: row3Val,
						showEdit: this.props.value ? true : false,
						defaultValue: '',
						bold,
						normal
					});
				}
			});
		}

	}

	// life cycle hook
	componentWillUnmount() {
		window.removeEventListener('click', this.handleWindowClick);
	}

	componentWillReceiveProps(nextProps) {
		if (this.props.value !== nextProps.value && (nextProps.value === undefined || nextProps.value === null || nextProps.value !== '')) {
			nextProps.data.forEach(optionData => {
				if (optionData.lid === nextProps.value) {
					var row1Val = this.generateText(nextProps.requiredFields.row1, optionData, nextProps.requiredFieldsPrefixes.row1, this.props.formatters.row1)
					var row2Val = this.generateText(nextProps.requiredFields.row2, optionData, nextProps.requiredFieldsPrefixes.row2, this.props.formatters.row2)
					var row3Val = this.generateText(nextProps.requiredFields.row3, optionData, nextProps.requiredFieldsPrefixes.row3, this.props.formatters.row3)
					var bold = row1Val.split(' ').slice(0, 3).join(' ');
					var normal = row1Val.split(' ').slice(3).join(' ');

					//
					if (optionData !== undefined && optionData.otherAccount !== 'undefined' && optionData.otherAccount === true) {
						let displayEdit = true
						this.setState({
							selectedOptionValue: undefined,
							selectedOption: undefined,
							defaultValue: '',
							bold,
							normal,
							valueRow1: row1Val,
							valueRow2: row2Val,
							valueRow3: row3Val,
							showEdit: displayEdit
						});
					} else if (this.props.flag !== undefined && this.props.flag === true) {
						this.setState({
							selectedOptionValue: undefined,
							selectedOption: undefined,
							defaultValue: '',
							bold,
							normal,
							valueRow1: row1Val,
							valueRow2: row2Val,
							valueRow3: row3Val,
							showEdit: true
						});
					} else {
						this.setState({
							selectedOptionValue: undefined,
							selectedOption: undefined,
							defaultValue: '',
							bold,
							normal,
							valueRow1: row1Val,
							valueRow2: row2Val,
							valueRow3: row3Val,
							showEdit: false
						});
					}
				}
			})


		} else {
			const selectedOptionValue = nextProps.value;
			let selectedOption;
			if (this.props.multiAccount === true) {
				nextProps.data.forEach(optionData => {
					if (optionData.lid === nextProps.value) {
						selectedOption = optionData;
						var row1Val = this.generateText(nextProps.requiredFields.row1, optionData, nextProps.requiredFieldsPrefixes.row1, this.props.formatters.row1)
						var row2Val = this.generateText(nextProps.requiredFields.row2, optionData, nextProps.requiredFieldsPrefixes.row2, this.props.formatters.row2)
						var row3Val = this.generateText(nextProps.requiredFields.row3, optionData, nextProps.requiredFieldsPrefixes.row3, this.props.formatters.row3)

						var bold = row1Val.split(' ').slice(0, 3).join(' ');
						var normal = row1Val.split(' ').slice(3).join(' ');

						let displayEdit = false;

						if (selectedOption !== undefined && selectedOption.otherAccount !== 'undefined' && selectedOption.otherAccount === true) {
							displayEdit = true
						} else {
							displayEdit = false
						}

						this.setState({
							selectedOption,
							selectedOptionValue,
							valueRow1: row1Val,
							valueRow2: row2Val,
							valueRow3: row3Val,
							showEdit: displayEdit,
							bold,
							normal,
							defaultValue: ''
						});
					}
				});
			} else {
				nextProps.data.forEach(optionData => {
					if (optionData.lid === nextProps.value) {
						selectedOption = optionData;
						var row1Val = this.generateText(nextProps.requiredFields.row1, optionData, nextProps.requiredFieldsPrefixes.row1, this.props.formatters.row1)
						var row2Val = this.generateText(nextProps.requiredFields.row2, optionData, nextProps.requiredFieldsPrefixes.row2, this.props.formatters.row2)
						var row3Val = this.generateText(nextProps.requiredFields.row3, optionData, nextProps.requiredFieldsPrefixes.row3, this.props.formatters.row3)

						var bold = row1Val.split(' ').slice(0, 3).join(' ');
						var normal = row1Val.split(' ').slice(3).join(' ');

						this.setState({
							selectedOption,
							selectedOptionValue,
							valueRow1: row1Val,
							valueRow2: row2Val,
							valueRow3: row3Val,
							showEdit: true,
							bold,
							normal,
							defaultValue: ''
						});
					}
				});
			}

		}

		if (nextProps.value === '') {
			this.setState({
				showEdit: false,
				selectedOption: [],
				selectedOptionValue: '',
				valueRow1: '',
				valueRow2: '',
				valueRow3: '',
				bold: '',
				normal: '',
				defaultValue: nextProps.defaultValue
			})
		}
	}

	// toggle list
	toggleMenu = (e) => {
		e.stopPropagation()
		this.setState(prevState => ({
			listShow: !prevState.listShow,
		}))
	}
	toggleMenuOnEnter = (e) => {
		if (e.keyCode === 13) {
			e.stopPropagation()
			this.setState(prevState => ({
				listShow: !prevState.listShow,
			}))
		}
	}

	// list click handler
	handleSelectClick = (selectedOption, event) => {
		event.stopPropagation();

		if (this.props.multiAccount === true) {
			var row1Val = this.generateText(this.props.requiredFields.row1, selectedOption, this.props.requiredFieldsPrefixes.row1, this.props.formatters.row1)
			var row2Val = this.generateText(this.props.requiredFields.row2, selectedOption, this.props.requiredFieldsPrefixes.row2, this.props.formatters.row2)
			var row3Val = this.generateText(this.props.requiredFields.row3, selectedOption, this.props.requiredFieldsPrefixes.row3, this.props.formatters.row3)

			var bold = row1Val.split(' ').slice(0, 3).join(' ');
			var normal = row1Val.split(' ').slice(3).join(' ');

			let displayEdit;
			if (selectedOption !== undefined && selectedOption.otherAccount !== undefined && selectedOption.otherAccount === true) {
				displayEdit = true
			} else {
				displayEdit = false
			}

			this.setState({
				selectedOption,
				selectedOptionValue: event.target.getAttribute("value"),
				listShow: false,
				showEdit: displayEdit,
				valueRow1: row1Val,
				valueRow2: row2Val,
				valueRow3: row3Val,
				bold,
				normal,
				defaultValue: ''
			})
		} else {
			var row1Val1 = this.generateText(this.props.requiredFields.row1, selectedOption, this.props.requiredFieldsPrefixes.row1, this.props.formatters.row1)
			var row2Val1 = this.generateText(this.props.requiredFields.row2, selectedOption, this.props.requiredFieldsPrefixes.row2, this.props.formatters.row2)
			var row3Val1 = this.generateText(this.props.requiredFields.row3, selectedOption, this.props.requiredFieldsPrefixes.row3, this.props.formatters.row3)

			var boldText = row1Val1.split(' ').slice(0, 3).join(' ');
			var normalText = row1Val1.split(' ').slice(3).join(' ');

			this.setState({
				selectedOption,
				selectedOptionValue: event.target.getAttribute("value"),
				listShow: false,
				showEdit: true,
				valueRow1: row1Val1,
				valueRow2: row2Val1,
				valueRow3: row3Val1,
				bold: boldText,
				normal: normalText,
				defaultValue: ''
			})
		}

		if (this.props._onChange && typeof (this.props._onChange) === "function") {
			this.props._onChange(selectedOption, this.props.selectType);
		}
	}

	// handle edit list item
	handleEdit = (event) => {
		event.stopPropagation();
		if (this.props.onEdit && typeof (this.props.onEdit) === "function") {
			this.props.onEdit(this.state.selectedOption, this.props.editFormLink, this.props.selectType);
		}
	}
	handleEditOnEnter = (event) => {
		if (event.keyCode === 13) {
			event.stopPropagation();
			if (this.props.onEdit && typeof (this.props.onEdit) === "function") {
				this.props.onEdit(this.state.selectedOption, this.props.editFormLink, this.props.selectType);
			}
		}
	}

	getSalutation = (item) => {
		var currentWord = Translations(this.props.salutations, this.props.lang.currentLang.lang, this.props.lang.translatedData)
		const salutation = convertStringToArrayForOption(currentWord);
		if (salutation !== undefined) {
			salutation.filter(countItem => {
				if ('title' in item) {
					if (countItem.split('=')[0] === item.title.value) {
						item.title.name = countItem.split('=')[1]
					}
				}
			})
			return item;
		}
	}

	// create text
	generateText = (row, data, prefixes = [], formatters = []) => {
		return row.reduce((acc, item, index) => {
			let _value;
			// capturing value from object
			if (data[item] !== undefined && data[item] !== "") {
				if (typeof data[item] === 'object' && data[item].name !== undefined) {
					if (item === "title") {
						_value = this.getSalutation(data)[item].name
					} else {
						_value = data[item].name;
					}
				}
				else {
					_value = data[item];
				}
			}
			// formating captured value using formatter callback
			if (_value && formatters[index]) {
				_value = formatters[index](data, _value);
			}
			// adding prefix to value and pushing it to accumulator
			if (_value) {
				acc.push((prefixes[index] !== undefined && prefixes[index] !== "") ? (`${prefixes[index]}: ${_value}`) : _value);
			}
			return acc;
		}, [])
			.join(', ');
		// return row.map( (item, index) => {
		// 	let _value;
		// 	if( typeof data[item] === 'object') {
		// 		_value = data[item].name
		// 	} else {
		// 		_value = data[item]
		// 	}
		// 	return (prefixes[index] !== undefined && prefixes[index] !== "") ? (`${prefixes[index]}: ${_value}`) : _value;
		// }).join(', ')
	}

	render() {
		const { valueRow2, valueRow3, listShow, showEdit, defaultValue, bold, normal } = this.state
		let ariaActiveDescendant = null
		let optionsJsx = this.props.data.map(optionData => {
			var row1Val = this.generateText(this.props.requiredFields.row1, optionData, this.props.requiredFieldsPrefixes.row1, this.props.formatters.row1)
			var row2Val = this.generateText(this.props.requiredFields.row2, optionData, this.props.requiredFieldsPrefixes.row2, this.props.formatters.row2)
			var row3Val = this.generateText(this.props.requiredFields.row3, optionData, this.props.requiredFieldsPrefixes.row3, this.props.formatters.row3)
			const optionDisabled = this.props.disabledOptions.indexOf(optionData.id) !== -1;
			const optionCss = classnames('gdoc-multiline-select-list-item', {
				'disabled': optionDisabled
			});
			if (this.props.value === optionData.id) {
				ariaActiveDescendant = this.props.id ? "mulitline-select-" + this.props.id + "-option-" + optionData.id : "mulitline-select-option-" + optionData.id
			}
			return (
				<li
					className={optionCss}
					id={this.props.id ? "mulitline-select-" + this.props.id + "-option-" + optionData.id : "mulitline-select-option-" + optionData.id} // Need to provide unique id for aria-activedescendant
					tabIndex={!optionDisabled ? "0" : "-1"}
					role="option"
					aria-selected={this.props.value === optionData.id} // selectedOptionValue shows disabled upon debugging
					key={optionData.id}
					value={optionData.id}
					onClick={!optionDisabled ? this.handleSelectClick.bind(this, optionData) : (e) => { e.stopPropagation() }}
					// onKeyDown={!optionDisabled ? this.handleSelectClick.bind(this, optionData) : (e) => { e.stopPropagation() }}
					onKeyDown={
						!optionDisabled
							? (event) => {
								if (event.code === 'Enter' || event.keyCode === 13 || event.key === 'Enter') {
									this.handleSelectClick(optionData, event);
								}
							}
							: (event) => { event.stopPropagation() }
					}
				>
					<div className="gdoc-block-sec">{row1Val}</div>
					<div className="gdoc-block-sec">{row2Val}</div>
					<div className="gdoc-block-sec">{row3Val}</div>
				</li>)
		});
		let listJsx = (
			<ul
				className="gdoc-multiline-select-list"
				id={"multiline-select-listbox-" + (this.props.id || this.props.value)}
				role="listbox"
				aria-labelledby={this.props.id + '__label'}
			>
				{optionsJsx}
			</ul>
		); // Need to provide unique id for aria-controls

		const isDisable = classnames('multiline-container', {
			'is_disabled': this.props.isDisable
		})

		return (
			<div className={isDisable}>
				<div
					id={this.props.id ? "mulitline-select-" + this.props.id : "mulitline-select"}
					className="gdoc-multiline-select"
					role="combobox"
					aria-activedescendant={ariaActiveDescendant} // Should match the id of the selected <li>
					aria-controls={"multiline-select-listbox-" + (this.props.id || this.props.value)} // Should be the id of the <ul> of the listbox
					aria-expanded={listShow ? "true" : "false"}
					aria-haspopup="listbox"
					aria-labelledby={`${this.props.id + '__label'} ${this.props.id ? "mulitline-select-" + this.props.id : "mulitline-select"}`}
					tabIndex="0"
					onClick={this.toggleMenu}
					onKeyUp={this.toggleMenuOnEnter}
				>
					<div className={this.props.className ? `${this.props.className} gdoc-multiline-container` : "gdoc-multiline-container"} >
						<div className="gdoc-multiline-leftSection">
							<div className="gdoc-multiline-select-list-selected-item">
								<div className="gdoc-block-sec default-sec">{this.props.defaultValue || defaultValue}</div>
								<div className="gdoc-block-sec"><strong>{bold} {normal}</strong></div>
								<div className="gdoc-block-sec">{valueRow2}</div>
								<div className="gdoc-block-sec">{valueRow3}</div>
							</div>
						</div>
						<div className="gdoc-multiline-rightSection">
							<div>
								{
									showEdit &&
									<i
										className="multiline-select-icon multiline-select-icon-edit"
										tabIndex="0" role="link"
										onClick={this.handleEdit}
										onKeyUp={this.handleEditOnEnter}
									></i>
								}
							</div>
							<div className='multiline-select-separator'></div>
							<div>
								{
									listShow
										? <i className="icon icon-multiline-select-up-arrow multiline-select-arrow" aria-hidden="true"></i>
										: <i className="icon icon-multiline-select-down-arrow multiline-select-arrow" aria-hidden="true"></i>
								}
							</div>
						</div>
					</div>
					{
						listShow ? listJsx : ''
					}
				</div>
			</div>
		)
	}
}

MultiLineSelect.defaultProps = {
	requiredFields: {},
	defaultValue: 'Please Select',
	requiredFieldsPrefixes: {
		"row1": [],
		"row2": [],
		"row3": []
	},
	formatters: {
		"row1": [],
		"row2": [],
		"row3": []
	},
	disabledOptions: [],
	multiAccount: false,
	isDisable: false
}

MultiLineSelect.propTypes = {
	requiredFields: PropTypes.object,
	requiredFieldsPrefixes: PropTypes.object,
	data: PropTypes.arrayOf(PropTypes.object),
	defaultValue: PropTypes.string,
	_onChange: PropTypes.func,
	onEdit: PropTypes.func,
	disabledOptions: PropTypes.arrayOf(PropTypes.string),
	isDisable: PropTypes.bool
}

export default MultiLineSelect



// WEBPACK FOOTER //
// ./src/components/common/MultiLineSelect/index.js